<script setup>
import { ref } from "vue";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import * as worker from "pdfjs-dist/build/pdf.worker";
// ./node_modules/pdfjs-dist/build/pdf.worker.entry.js
pdfjsLib.GlobalWorkerOptions.workerSrc = "@/node_modules/pdfjs-dist/build/pdf.worker.entry.js";
    // "https://npmcdn.com/pdfjs-dist@2.15.349/build/pdf.worker.js";

const pdfHolder = ref(null);

const loadPDF = async (url) => {
  pdfjsLib
    .getDocument({ url: url, withCredentials: true })
    .promise.then(async function (pdf) {
      let options = { scale: 1 };

      async function renderPage(page) {
        let viewport = page.getViewport(options);
        let pdfCanvas = document.createElement("canvas");

        let ctx = pdfCanvas.getContext("2d");
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };

        pdfCanvas.height = viewport.height;
        pdfCanvas.width = viewport.width;
        pdfHolder.value.appendChild(pdfCanvas);

        await page.render(renderContext);
      }

      pdfHolder.value.innerHTML = "";
      for (let num = 1; num <= pdf.numPages; num++) {
        let p = await pdf.getPage(num);
        await renderPage(p);
      }
    });
}
defineExpose({
  loadPDF,
});
</script>

<template>
  <div ref="pdfHolder"></div>
</template>
